import { ReactNode } from "react";
import styled from "styled-components";
import ProcessStateImage, { ProcessStateImageProps } from "./ProcessStateImage";
import ClientNameBox, { ClientNameBoxProps } from "./ClientNameBox";
import ClientConsentContext from "./ConsentContext";

const Container = styled.div<{ $allowGrow?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  width: 100%;
  max-width: none;
  height: auto;
  min-height: auto;
  padding: 0;
  border-radius: 8px;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    width: 100%;
    height: auto;
  }
`;

const Title = styled.h2`
  font-family: ${({ theme }) => theme.headingFontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 3rem;
  line-height: 3.6rem;
  color: #23231f;
  margin: 0;
  @media screen and (max-width: 480px) {
    font-size: 2rem;
    line-height: 2.4rem;
  }
`;

export interface ClientConsentContext {
  clientContextHeaderText: string;
  clientContextText?: string | undefined;
}

export interface ProcessContextBlockProps {
  title: string;
  isDesktop: boolean;
  displayClientConsentContext: boolean;
  clientNameBox: ClientNameBoxProps | undefined;
  clientConsentContext: ClientConsentContext | undefined;
  processStateImage: ProcessStateImageProps | undefined;
  extraContent?: ReactNode;
}

export default function ProcessContextBlock({
  title,
  isDesktop,
  displayClientConsentContext,
  clientNameBox,
  clientConsentContext,
  processStateImage,
  extraContent,
}: ProcessContextBlockProps): JSX.Element {
  return (
    <Container data-testid="process_context" $allowGrow={!!extraContent}>
      <Title data-testid="title">{title}</Title>
      {!!clientNameBox && !!!clientConsentContext && (
        <ClientNameBox
          clientName={clientNameBox.clientName}
          clientLogo={clientNameBox.clientLogo}
          display={clientNameBox.display}
        />
      )}
      {!!clientNameBox &&
        !!clientConsentContext &&
        !displayClientConsentContext && (
          <ClientNameBox
            clientName={clientNameBox.clientName}
            clientLogo={clientNameBox.clientLogo}
            display={clientNameBox.display}
          />
        )}
      {!!clientNameBox &&
        !!clientConsentContext &&
        displayClientConsentContext && (
          <ClientConsentContext
            clientContextHeaderText={
              clientConsentContext.clientContextHeaderText
            }
            isDesktop={isDesktop}
            clientName={clientNameBox?.clientName}
            clientLogo={clientNameBox?.clientLogo}
            clientContextText={clientConsentContext.clientContextText}
          />
        )}
      {!!processStateImage && (
        <ProcessStateImage state={processStateImage.state} />
      )}
      {!!extraContent && extraContent}
    </Container>
  );
}
